import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-319ffc77")

_pushScopeId("data-v-319ffc77")
const _hoisted_1 = { class: "post" }
const _hoisted_2 = {
  key: 0,
  class: "post-meta"
}
const _hoisted_3 = { class: "post-icon" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_5 = { class: "post-title" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_text_module = _resolveComponent("text-module")!
  const _component_code_module = _resolveComponent("code-module")!
  const _component_gallery_module = _resolveComponent("gallery-module")!
  const _component_image_module = _resolveComponent("image-module")!
  const _component_post_listing_module = _resolveComponent("post-listing-module")!
  const _component_read_more_module = _resolveComponent("read-more-module")!
  const _component_disqus_module = _resolveComponent("disqus-module")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock("article", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.post.modules, (module) => {
      return (_openBlock(), _createBlock(_Fragment, null, [
        (module.type === 'text-module')
          ? (_openBlock(), _createBlock(_component_text_module, {
              key: 0,
              module: module
            }, null, 8, ["module"]))
          : _createCommentVNode("", true),
        (module.type === 'code-module')
          ? (_openBlock(), _createBlock(_component_code_module, {
              key: 1,
              module: module
            }, null, 8, ["module"]))
          : _createCommentVNode("", true),
        (module.type === 'gallery-module')
          ? (_openBlock(), _createBlock(_component_gallery_module, {
              key: 2,
              module: module
            }, null, 8, ["module"]))
          : _createCommentVNode("", true),
        (module.type === 'image-module')
          ? (_openBlock(), _createBlock(_component_image_module, {
              key: 3,
              module: module
            }, null, 8, ["module"]))
          : _createCommentVNode("", true),
        (module.type === 'post-listing-module')
          ? (_openBlock(), _createBlock(_component_post_listing_module, {
              key: 4,
              module: module
            }, null, 8, ["module"]))
          : _createCommentVNode("", true),
        (module.type === 'read-more-module')
          ? (_openBlock(), _createBlock(_component_read_more_module, {
              key: 5,
              module: module,
              post: _ctx.post
            }, null, 8, ["module", "post"]))
          : _createCommentVNode("", true),
        (module.type === 'disqus-module')
          ? (_openBlock(), _createBlock(_component_disqus_module, {
              key: 6,
              module: module,
              post: _ctx.post
            }, null, 8, ["module", "post"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 256)),
    (!_ctx.hideMeta)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_font_awesome_icon, { icon: "file-alt" }),
            _hoisted_4
          ]),
          _createVNode("span", _hoisted_5, [
            _createVNode("a", {
              href: _ctx.post.url
            }, "Posted " + _toDisplayString(_ctx.postDate(_ctx.post.date)), 9, ["href"]),
            _hoisted_6,
            (_ctx.post.category)
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  href: _ctx.post.category.url
                }, "in " + _toDisplayString(_ctx.post.category.title), 9, ["href"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})